export default "__VITE_ASSET__CHl3J5ZT__"